export default __webpack_public_path__ + "static/media/chatplus.59daaa9a.svg";